import { render, staticRenderFns } from "./BollettazioneForm.vue?vue&type=template&id=8ae0ca5e"
import script from "./BollettazioneForm.vue?vue&type=script&lang=js"
export * from "./BollettazioneForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports